import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

const ThemeProvider = ({children}) => {
    const [theme, setTheme] = useState({
        logo: '/static/rezify_logo2.png',
        primary_color: '#DB3A00',
        hover_color: '#ff4500',
        provider: "all"   // default behavior
    });


    return (
        <ThemeContext.Provider value={{theme, setTheme}}>
        {children}
        </ThemeContext.Provider>
    );
};

const useTheme = () => useContext(ThemeContext)

// Helper function to convert hex color to RGB values
const colorToRgb = (color) => {
  if (!color) return "219, 58, 0"; // fallback

  // Create a temporary element to let the browser resolve the color
  const temp = document.createElement("div");
  temp.style.color = color;
  document.body.appendChild(temp);

  // Get computed RGB value: "rgb(r, g, b)" or "rgba(r, g, b, a)"
  const computed = getComputedStyle(temp).color;
  document.body.removeChild(temp);

  const match = computed.match(/\d+/g);
  if (!match || match.length < 3) {
    return "219, 58, 0"; // fallback
  }

  return `${match[0]}, ${match[1]}, ${match[2]}`;
};


const updateColors = (parsedData, setTheme) => {
    /*
    Takes in parsed json color data, either from localStorage or an API fetch, and updates colors and returns the logo in use
    */
   if (parsedData) {
        document.documentElement.style.setProperty('--primary-color', parsedData.primary_color);
        document.documentElement.style.setProperty('--primary-color-rgb', colorToRgb(parsedData.primary_color));
        document.documentElement.style.setProperty('--logo', "/static/" + parsedData.logo);
        document.documentElement.style.setProperty('--hover-color', parsedData.hover_color);
        document.documentElement.style.setProperty('--text-against-pc', parsedData.text_against_pc);
        setTheme(prev => ({
            ...prev,
            logo: "/static/school_logos/" + parsedData.logo,
            primary_color: parsedData.primary_color,
            hover_color: parsedData.hover_color,
            provider: parsedData.provider || ""   // store provider from backend
        }));

   }
}

export {ThemeProvider, useTheme, updateColors};